import './plan-price.style.sass';
import template from './plan-price.tpl.pug';

class PlanPriceController {
    $onChanges(changeObject) {
        if (changeObject.price) {
            this.integer = this.getIntegerPartOfPrice(changeObject.price.currentValue || 0);
            this.fractional = this.getFractionalPartOfPrice(changeObject.price.currentValue || 0);
        }

        this.currency = this.currency || null;
    }

    getIntegerPartOfPrice(price) {
        return Math.floor(Math.abs(price));
    }

    getFractionalPartOfPrice(price) {
        let fractional = +(Math.abs(price) % 1);
        return fractional === 0
            ? '00'
            : fractional.toFixed(2).substring(2);
    }
}

export default {
    selector: 'dbPlanPrice',
    template: template(),
    controller: PlanPriceController,
    bindings: {
        currency: '<',
        price: '<'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/component/plan-price/plan-price.cmpt.js